import React, { useRef } from 'react'
import MoreButtonWrapper from '../Common/MoreButtonWrapper'
import CopyLinkModalItem from '../../MorePopupsOfEditModals/Common/CopyLinkModalItem'
import { useSelector } from 'react-redux'
import { FOLLOWED_TAB } from '../../../../Feeds/Utils/FeedsConstants'
import OpenInNewWindowModalItem from '../Common/OpenInNewWindowModalItem'
import OpenProjectModalItem from '../Common/OpenProjectModalItem'

export default function ContactMoreButton({
    projectId,
    user,
    wrapperStyle,
    buttonStyle,
    disabled,
    shortcut = 'M',
    iconSize,
}) {
    const contactsActiveTab = useSelector(state => state.contactsActiveTab)
    const tab = contactsActiveTab === FOLLOWED_TAB ? 'followed' : 'all'
    const modalRef = useRef()
    const link = projectId
        ? `${window.location.origin}/projects/${projectId}/user/${user.uid}/contacts/${tab}`
        : `${window.location.origin}/projects/contacts/${tab}`

    const dismissModal = () => {
        modalRef?.current?.close()
    }

    const renderItems = () => {
        const list = []

        list.push(shortcut => {
            return <CopyLinkModalItem key={'gmbtn-copy-link'} link={link} shortcut={shortcut} onPress={dismissModal} />
        })

        list.push(shortcut => {
            return <OpenInNewWindowModalItem key={'gmbtn-open-new-win'} shortcut={shortcut} onPress={dismissModal} />
        })

        return list
    }

    return (
        <MoreButtonWrapper
            ref={modalRef}
            buttonStyle={buttonStyle}
            disabled={disabled}
            shortcut={shortcut}
            wrapperStyle={wrapperStyle}
            iconSize={iconSize}
        >
            {projectId && <OpenProjectModalItem projectId={projectId} shortcut={'1'} onPress={dismissModal} />}
            {renderItems().map((item, index) => item((index + (projectId ? 2 : 1)).toString()))}
        </MoreButtonWrapper>
    )
}
